import { render } from "./FilterGalleriesV2.vue?vue&type=template&id=f97b0f98&scoped=true"
import script from "./FilterGalleriesV2.vue?vue&type=script&lang=js"
export * from "./FilterGalleriesV2.vue?vue&type=script&lang=js"

import "./FilterGalleriesV2.vue?vue&type=style&index=0&id=f97b0f98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f97b0f98"

export default script